var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputTypePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6.16663C8.27614 6.16663 8.5 6.39048 8.5 6.66663V9.33329C8.5 9.60943 8.27614 9.83329 8 9.83329C7.72386 9.83329 7.5 9.60943 7.5 9.33329V6.66663C7.5 6.39048 7.72386 6.16663 8 6.16663Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78055 7.10975C9.90405 7.35674 9.80394 7.65708 9.55695 7.78058L6.89028 9.11391C6.64329 9.2374 6.34296 9.13729 6.21946 8.8903C6.09597 8.64331 6.19608 8.34298 6.44307 8.21948L9.10973 6.88615C9.35672 6.76265 9.65706 6.86277 9.78055 7.10975Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.21946 7.10975C6.34296 6.86277 6.64329 6.76265 6.89028 6.88615L9.55695 8.21948C9.80394 8.34298 9.90405 8.64331 9.78055 8.8903C9.65706 9.13729 9.35672 9.2374 9.10973 9.11391L6.44307 7.78058C6.19608 7.65708 6.09597 7.35674 6.21946 7.10975Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33334 6.16663C3.60949 6.16663 3.83334 6.39048 3.83334 6.66663V9.33329C3.83334 9.60943 3.60949 9.83329 3.33334 9.83329C3.0572 9.83329 2.83334 9.60943 2.83334 9.33329V6.66663C2.83334 6.39048 3.0572 6.16663 3.33334 6.16663Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11387 7.10975C5.23736 7.35674 5.13725 7.65708 4.89026 7.78058L2.22359 9.11391C1.97661 9.2374 1.67627 9.13729 1.55277 8.8903C1.42928 8.64331 1.52939 8.34298 1.77638 8.21948L4.44305 6.88615C4.69004 6.76265 4.99037 6.86277 5.11387 7.10975Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55277 7.10975C1.67627 6.86277 1.97661 6.76265 2.22359 6.88615L4.89026 8.21948C5.13725 8.34298 5.23736 8.64331 5.11387 8.8903C4.99037 9.13729 4.69004 9.2374 4.44305 9.11391L1.77638 7.78058C1.52939 7.65708 1.42928 7.35674 1.55277 7.10975Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 6.16663C12.9428 6.16663 13.1667 6.39048 13.1667 6.66663V9.33329C13.1667 9.60943 12.9428 9.83329 12.6667 9.83329C12.3905 9.83329 12.1667 9.60943 12.1667 9.33329V6.66663C12.1667 6.39048 12.3905 6.16663 12.6667 6.16663Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4472 7.10975C14.5707 7.35674 14.4706 7.65708 14.2236 7.78058L11.5569 9.11391C11.3099 9.2374 11.0096 9.13729 10.8861 8.8903C10.7626 8.64331 10.8627 8.34298 11.1097 8.21948L13.7764 6.88615C14.0234 6.76265 14.3237 6.86277 14.4472 7.10975Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8861 7.10975C11.0096 6.86277 11.3099 6.76265 11.5569 6.88615L14.2236 8.21948C14.4706 8.34298 14.5707 8.64331 14.4472 8.8903C14.3237 9.13729 14.0234 9.2374 13.7764 9.11391L11.1097 7.78058C10.8627 7.65708 10.7626 7.35674 10.8861 7.10975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputTypePassword);
export default __webpack_public_path__ + "static/media/input_type_password.81de12dabbea595fa98e27345d7b3bc1.svg";
export { ForwardRef as ReactComponent };